import api from '@/lib/api';
import { parseActivityUpdateResponse } from '@/lib/merge_activities';

// The SINGLE write path for a Collaborator's Actual Start / Actual Finish edit
// on mobile. Routes through the SAME endpoint the desktop inline editor uses —
// PUT /activities/{id}/progress with a partial ProgressUpdate body — so the
// existing server-side enforcement applies to mobile UNCHANGED:
//   - require_can(Action.EDIT_ACTUALS)              (collaborate+ on the project)
//   - the collaborator field-allowlist               (actual_start / actual_finish only)
// both in backend/domains/activities/routes.py. The mobile UI must NOT introduce
// any alternate write path (e.g. the generic PUT /activities/{id}, which skips
// the field-allowlist — see ActivityEditDialog).
//
// Funneling every write through this one function means a Phase-2 offline queue
// can wrap THIS function rather than touching call sites.
//
// @param activityId  activity.id (Mongo id, not the human activity_id)
// @param field       'actual_start' | 'actual_finish'
// @param value       'YYYY-MM-DD' to set, or null/'' to clear
// @returns { activity, cascaded } — feed [activity, ...cascaded] to
//          handleActivitiesMerged so downstream CPM dates update in place.
export async function saveActualDate(activityId, field, value) {
  if (field !== 'actual_start' && field !== 'actual_finish') {
    // Defense-in-depth: the backend also rejects this, but never let a caller
    // smuggle a non-actual field through the collaborator save path.
    throw new Error(`saveActualDate: refusing to write non-actual field "${field}"`);
  }
  const payload = { [field]: value || null };
  const res = await api.put(`/activities/${activityId}/progress`, payload);
  return parseActivityUpdateResponse(res.data);
}

export default saveActualDate;
